import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
} from '../../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


const unitQuery = `
    costCenter(id: $id) {
        id
        isActive
        enterpriseId
        name
        parent {
            id
            enterpriseId
        }
        manager {
            id
            enterpriseId
        }
    }
`
const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allCostCenters'), unitQuery}

class InventoryCostCenterMinimalTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InventoryCostCenterMinimalTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.addDescriptions ([
            new TableFieldDescription(
                'enterpriseId',
                new DataMapper("enterpriseId"),
                new f.FilterDescription(new f.TextFilter("enterpriseId")),
                {label: 'Code'}
            ),
            new TableFieldDescription(
                'name',
                new DataMapper("name"),
                new f.FilterDescription(new f.TextFilter("name")),
                {label: 'Name'}
            ),
            new TableFieldDescription(
                'parent',
                new DataMapper("parent.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("parent")),
                {label: 'Parent'}
            )
        ])

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InventoryCostCenterMinimalTableCreator)

export default InventoryCostCenterMinimalTableCreator
